// const logger = (msg) => {
//     if(process.env.NODE_ENV==="development") {
//         return console.log(msg);
//     }
// }
const logger = () => {
    if(process.env.NODE_ENV==="development") {
        return console.log;
    }
    return (msg) => {}
}
export default logger;